export default __webpack_public_path__ + "static/media/Reader's Gloves of the Forbidden Art.33e08143.jpg";